module.exports = __webpack_public_path__ + "img/7816d7e5d8057246c9fbb4319f7a70c3.png";